import React from "react";
import Tabs from '../Tabs/Tabs';
import ModalButtons from "../ModalButtons/ModalButtons"
import CashDrawerPresenterWorkspace from "./CashDrawerPresenterWorkspace";

export default class CashDrawerPresenter extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      active_tab: 'general',
      cash_drawer: this.props.cash_drawer,
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
  }

  /**
   * Render functions
   */

  render() {

    return (
      <div className="CashDrawerPresenter">
        <Tabs tabs={this.renderTabs()} />
        <div className="panel panel-form">
          <CashDrawerPresenterWorkspace {...this.props} {...this.state} />
          <ModalButtons loading={this.state.loading} buttons={this.renderButtons()} />
        </div>
      </div>
    )
  }

  renderButtons() {
    return [
      {
        name: I18n.t('ok'),
        html_attributes: [
          'data-dismiss="modal"'
        ],
      },
    ];
  }

  renderTabs() {
    return [
      {
        tabName: I18n.t('general'),
        targetName: 'general',
        classes: this.state.active_tab === 'general' ? 'active' : null,
        changeHandler: this.onChangeActiveTab,
        tabErrorCount: 0
      },
      {
        tabName: I18n.t('transactions'),
        targetName: 'transactions',
        classes: this.state.active_tab === 'transactions' ? 'active' : null,
        changeHandler: this.onChangeActiveTab,
        tabErrorCount: 0
      }
    ]
  }

  onChangeActiveTab(name) {
    this.setState({active_tab: name})
  }

}
